import { render, staticRenderFns } from "./SampleSite.vue?vue&type=template&id=2550909e&scoped=true"
import script from "./SampleSite.vue?vue&type=script&lang=js"
export * from "./SampleSite.vue?vue&type=script&lang=js"
import style0 from "./SampleSite.vue?vue&type=style&index=0&id=2550909e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550909e",
  null
  
)

export default component.exports